export default {
  error: {
    error404Subtitle: '噢！你迷失了 ！',
    error404Title: '你找到頁面不存在。'
  }
}


// WEBPACK FOOTER //
// ./src/ErrorPage/langs/zh_hk/index.js